import { Contact } from '@/types/crm';

const normalizeKey = (value: string) =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '');

const LAST_INTERACTION_ALIASES = [
  'data_ultima_atualizacao',
  'atualizado_em',
  'updated_at',
  'ultima_atualizacao',
  'last_update',
  'last_interaction',
  'data_ultima_mensagem',
  'ultima_mensagem',
  'data_ultimo_contato',
  'ultimo_contato',
  'last_contact',
  'data_primeira_mensagem',
  'criado_em',
  'created_at',
];

export function getLeadSessionId(lead: Contact): string {
  return lead.session_id || lead.id;
}

export function parseFlexibleDate(dateStr: string | undefined | null): Date | null {
  if (!dateStr || typeof dateStr !== 'string') return null;

  const trimmed = dateStr.trim();
  if (!trimmed) return null;

  const isoDate = new Date(trimmed);
  if (!Number.isNaN(isoDate.getTime())) return isoDate;

  const brMatch = trimmed.match(
    /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/,
  );
  if (brMatch) {
    const [, d, m, y, hh = '0', mm = '0', ss = '0'] = brMatch;
    const parsed = new Date(
      Number(y),
      Number(m) - 1,
      Number(d),
      Number(hh),
      Number(mm),
      Number(ss),
    );
    if (!Number.isNaN(parsed.getTime())) return parsed;
  }

  return null;
}

export function getLeadLastInteractionDate(lead: Contact): Date | null {
  for (const alias of LAST_INTERACTION_ALIASES) {
    const parsed = parseFlexibleDate(lead[alias]);
    if (parsed) return parsed;
  }

  const normalizedAliases = LAST_INTERACTION_ALIASES.map(normalizeKey);
  for (const [key, value] of Object.entries(lead)) {
    if (typeof value !== 'string') continue;
    const normalizedKey = normalizeKey(key);
    if (normalizedAliases.includes(normalizedKey)) {
      const parsed = parseFlexibleDate(value);
      if (parsed) return parsed;
    }

    const looksLikeLastUpdate =
      (normalizedKey.includes('ultima') || normalizedKey.includes('last')) &&
      (normalizedKey.includes('atual') ||
        normalizedKey.includes('mensagem') ||
        normalizedKey.includes('interaction') ||
        normalizedKey.includes('contato') ||
        normalizedKey.includes('update'));

    if (looksLikeLastUpdate) {
      const parsed = parseFlexibleDate(value);
      if (parsed) return parsed;
    }
  }

  return null;
}